import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './ktostamm-kunde.list-view.html',
    styleUrls: ['./ktostamm-kunde.list-view.scss']
})
export class KtostammKundeListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
